import { I18N } from "aurelia-i18n";
import additionalFieldsService from "services/additionalFieldsService";
import { autoinject } from "aurelia-framework";
import { AdditionalFieldsSourceType } from "enums/additional-fields-source-type";
import routerHelper from "helpers/routerHelper";
import { FormBase } from "pages/form-base";
import { AdditionalFieldMapper } from "components/pages/additional-fields/helpers/additional-field-mapper";
import { NotificationHelper } from "helpers/notification-helper";
import { Router } from "aurelia-router";

@autoinject
export class FieldServiceAdditionalFields extends FormBase {

    public actions: any = {};
    public workOrderId: string = "";
    public readonly: any = false;
    public additionalFieldsSource: number = AdditionalFieldsSourceType.FieldService;
    public saveAdditionalFieldsButton: boolean = true;
    public currentFields: any = null;
    public unModifiedFields: any = null;

    constructor(i18n: I18N, notificationHelper: NotificationHelper, router: Router, private readonly additionalFieldMapper: AdditionalFieldMapper) {
        super(notificationHelper, i18n, router);
    }

    public checkDirty(): boolean {
        if (this.readonly) {
            return false;
        }

        return this.additionalFieldMapper.isNotEqual(this.unModifiedFields, this.currentFields);
    }

    public activate(params: any): any {
        this.bindViewModel(decodeURIComponent(params.workOrderId), params.q);
    }

    public bindViewModel(workOrderId: string, queryString: string): void {
        const params = routerHelper.getQuerystring(queryString);
        this.readonly = !(params && params.readonly === "false");

        this.workOrderId = workOrderId;

        this.actions = {
            getAll: additionalFieldsService.getAllForFieldService.bind(this, this.workOrderId),
            setAll: additionalFieldsService.setAllForFieldService.bind(this, this.workOrderId)
        };
    }

}
